import axios from "axios";
import {
	BaseResponse,
	Block,
	BlockPayload,
	BlockResponse,
} from "../types/block.type";

const API_URL = import.meta.env.VITE_APP_API_URL;

export const fetchBlockList = async (
	page = 1,
	limit = 10,
	search = "",
): Promise<any> => {
	const response = await axios.get(
		`${API_URL}/admin/block/list?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
	);
	// Handle both {items: []} and direct array responses
	if (response.data.data && response.data.data.items) {
		return response.data.data;
	}
	return {
		items: response.data.data || [],
		totalItems: (response.data.data || []).length,
	};
};

export const fetchBlockById = async (id: string | number): Promise<Block> => {
	const response = await axios.get(`${API_URL}/admin/block/view/${id}`);
	return response.data.data;
};

export const createBlock = async (
	payload: BlockPayload,
): Promise<BlockResponse> => {
	const response = await axios.post(`${API_URL}/admin/block/add`, payload);
	return response.data;
};

export const updateBlock = async (
	id: string | number,
	payload: BlockPayload,
): Promise<BlockResponse> => {
	const response = await axios.put(
		`${API_URL}/admin/block/edit/${id}`,
		payload,
	);
	return response.data;
};

export const deleteBlock = async (
	id: string | number,
): Promise<BaseResponse> => {
	const response = await axios.delete(`${API_URL}/admin/block/delete/${id}`);
	return response.data;
};

export const fetchBlocksByDistrict = async (
	districtId: string | number,
): Promise<any> => {
	const response = await axios.get(
		`${API_URL}/admin/master/blocks/${districtId}`,
	);
	const data = response.data.data || response.data;
	return Array.isArray(data) ? data : data?.items || [];
};
